import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layouts/Layout';
import PortalLayout from './layouts/PortalLayout';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import WhoWeAre from './pages/WhoWeAre';
import Programs from './pages/Programs';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import EventTicketThankYou from './pages/EventTicketThankYou';
import Gallery from './pages/Gallery';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import Give from './pages/Give';
import GiveThankYou from './pages/GiveThankYou';
import BoardMembers from './pages/BoardMembers';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RefundPolicy from './pages/RefundPolicy';
import SignIn from './pages/SignIn';
import PortalDashboard from './pages/PortalDashboard';
import PortalEvents from './pages/PortalEvents';
import PortalBoardMembers from './pages/PortalBoardMembers';
import PortalModelApplications from './pages/PortalModelApplications';
import PortalOrders from './pages/PortalOrders';
import PortalAccount from './pages/PortalAccount';
import { getPreviewBase } from './services/bliss-app-auth';

function App() {
  return (
    <BrowserRouter basename={getPreviewBase() || undefined}>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<WhoWeAre />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/events/:slug/thank-you" element={<EventTicketThankYou />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/give" element={<Give />} />
          <Route path="/give/thank-you" element={<GiveThankYou />} />
          <Route path="/board-members" element={<BoardMembers />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/who-we-are" element={<Navigate to="/about-us" replace />} />
          <Route path="/tickets" element={<Navigate to="/events" replace />} />
          <Route path="/forms" element={<Navigate to="/events" replace />} />
          <Route path="/magazines" element={<Navigate to="/resources" replace />} />
          <Route path="/blogs" element={<Navigate to="/resources" replace />} />
        </Route>

        <Route
          path="/portal"
          element={
            <ProtectedRoute>
              <PortalLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<PortalDashboard />} />
          <Route path="events" element={<PortalEvents />} />
          <Route path="board" element={<PortalBoardMembers />} />
          <Route path="models" element={<PortalModelApplications />} />
          <Route path="orders" element={<PortalOrders />} />
          <Route path="account" element={<PortalAccount />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
